import {IMAGE_SIZES, IMAGE_SIZE_MAP} from "./getResolutionImgUrl";
import {ImageSizeGroup} from "./imageUtils";

export default function getHeroImageSizeGroup(): ImageSizeGroup {
  const imageSizesNames = [
    IMAGE_SIZES.BRAND_HERO,
    IMAGE_SIZES.BRAND_HERO_MEDIUM,
    IMAGE_SIZES.BRAND_HERO_SMALL,
  ];
  const imageSizes = imageSizesNames.map(
    (sizeName) => IMAGE_SIZE_MAP[sizeName]
  );
  return new ImageSizeGroup(imageSizes);
}

/**
 * Chooses a valid max/min image size depending on the screen size. Uses our standard breakpoint values.
 * @returns {String} An image size constant, one of IMAGE_SIZES from global_functions.
 */
export function getHeroImageSize(): string {
  // Fallback for browsers that don't support srcset
  const viewWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  if (viewWidth <= 640) {
    return IMAGE_SIZES.BRAND_HERO_SMALL;
  } else if (viewWidth <= 1024) {
    return IMAGE_SIZES.BRAND_HERO_MEDIUM;
  }
  return IMAGE_SIZES.BRAND_HERO;
}
